import { render } from "./Background.vue?vue&type=template&id=41cf1e51&scoped=true"
import script from "./Background.vue?vue&type=script&lang=js"
export * from "./Background.vue?vue&type=script&lang=js"

import "./Background.vue?vue&type=style&index=0&id=41cf1e51&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-41cf1e51"

export default script